import { useState } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { App, Button, Card, Flex, Form, Input, Typography } from 'antd';
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { useAuth } from '../auth/AuthContext';
import { landingFor } from '../constants/roles';
import { toApiError } from '../api/client';

interface LoginForm {
  email: string;
  password: string;
}

export default function Login() {
  const { status, user, login } = useAuth();
  const { message } = App.useApp();
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  // Already signed in → send to the role's landing page.
  if (status === 'authenticated' && user) {
    return <Navigate to={landingFor(user.role)} replace />;
  }

  const from = (location.state as { from?: string } | null)?.from;

  const onFinish = async (values: LoginForm) => {
    setLoading(true);
    try {
      const me = await login(values.email, values.password);
      navigate(from ?? landingFor(me.role), { replace: true });
    } catch (err) {
      // Backend returns a generic message to prevent user enumeration (architecture §8.1).
      message.error(toApiError(err).message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Flex align="center" justify="center" style={{ minHeight: '100vh', background: '#f0f2f5' }}>
      <Card style={{ width: 380 }}>
        <Typography.Title level={4} style={{ textAlign: 'center', marginBottom: 24 }}>
          ورود به سامانه پایش مرکز تماس
        </Typography.Title>
        <Form<LoginForm> layout="vertical" onFinish={onFinish} requiredMark={false}>
          <Form.Item
            name="email"
            label="ایمیل"
            rules={[{ required: true, message: 'ایمیل را وارد کنید' }, { type: 'email', message: 'ایمیل معتبر نیست' }]}
          >
            <Input prefix={<UserOutlined />} autoComplete="username" size="large" dir="ltr" />
          </Form.Item>
          <Form.Item
            name="password"
            label="رمز عبور"
            rules={[{ required: true, message: 'رمز عبور را وارد کنید' }]}
          >
            <Input.Password prefix={<LockOutlined />} autoComplete="current-password" size="large" dir="ltr" />
          </Form.Item>
          <Form.Item style={{ marginBottom: 0 }}>
            <Button type="primary" htmlType="submit" block size="large" loading={loading}>
              ورود
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </Flex>
  );
}
